export const DEFAULT_MAX_INPUT_LENGTH = 35;
export const DOCUMENT_NAME_MAX_LENGTH = 80;
export const DESCRIPTION_MAX_LENGTH = 150;
export const UI_VIEW_PERMISSIONS = [ 'ui.*.*', 'ui.*', '*.*.*', '*.*', '*' ];
